import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { GlobalService } from '../shared/services/global.service';

@Injectable({
	providedIn: 'root'
})
export class TimelineService {

	public readonly BOX_SIZE = 25;

	getInfoPhasesProject(date, type, project_id, module, duration) {
		let data = {
			session_id: this._gS.session_token,
			date: date,
			preview_type: type == 'daily' ? 'day' : type == 'weekly' ? 'week' : 'month',
			project_id: project_id ? project_id : undefined,
			post: module.name == 'post' ? true : undefined,
			months: duration ? duration : 24
		};

		return this.http.post(this._gS.service_url + 'timeline/info_phases_project', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createPhaseProject(projectId, values) {
		let data = {
			session_id: this._gS.session_token,
			project_id: projectId,
			phase_id: values.phase_id,
			date_start: values.date_start,
			week: values.week
		};

		return this.http.post(this._gS.service_url + 'timeline/create_phases_project', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	listPredecessor(project_has_phase_id) {
		let data = {
			session_id: this._gS.session_token,
			project_has_phase_id: project_has_phase_id
		};

		return this.http.post(this._gS.service_url + 'timeline/list_predecessor', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createPhaseTask(values) {
		let data = {
			session_id: this._gS.session_token,
			id: values.id,
			project_has_phase_id: values.project_has_phase_id,
			task_name: values.task_name,
			predecessor_id: values.predecessor_id,
			task_start_at_id: values.task_start_at_id,
			task_unit_id: values.task_unit_id,
			duration: values.duration,
			task_duration_type_id: values.task_duration_type_id,
			break: values.break,
			break_task_duration_type_id: values.break_task_duration_type_id,
			work_days: values.work_days,
			break_episode: values.break_episode ? parseInt(values.break_episode) : null,
			post_color: values.post_color,
			position: values.position,
			task_countrys: values.task_countrys.length ? values.task_countrys.map(c => c.id) : null,
			date_task: values.date_task
		};

		return this.http.post(this._gS.service_url + 'timeline/create_task', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getProjectTasks(project_has_phase_id, date, duration) {
		return this.http.get(this._gS.service_url + 'timeline/get_phase_tasks', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('project_has_phase_id', project_has_phase_id)
				.set('start_date', date)
				.set('months', duration ? duration : 24)
		})
	}

	deletePhaseTask(task_id) {
		let data = {
			session_id: this._gS.session_token,
			id: task_id
		};

		return this.http.post(this._gS.service_url + 'timeline/delete_task', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	addBreakTask(values) {
		let data = {
			session_id: this._gS.session_token,
			task_id: values.task_id,
			apply: values.apply,
			value: values.value,
			episode: values.episode,
		};

		return this.http.post(this._gS.service_url + 'timeline/add_break', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	changeQuantityTask(values) {
		let data = {
			session_id: this._gS.session_token,
			task_id: values.task_id,
			apply: values.apply,
			quantity: values.quantity,
			episode: values.episode
		};

		return this.http.post(this._gS.service_url + 'timeline/change_quantity', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	changeDurationTask(values) {
		let data = {
			session_id: this._gS.session_token,
			task_id: values.task_id,
			apply: values.apply,
			duration: values.duration,
			episode: values.episode
		};

		return this.http.post(this._gS.service_url + 'timeline/change_duration', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	newTaskPosition(values) {
		let data = {
			session_id: this._gS.session_token,
			task_id: values.task_id,
			old_position: values.old_position,
			new_position: values.new_position
		};

		return this.http.post(this._gS.service_url + 'timeline/new_task_position', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getHolidays(project?) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project ? project.id : null
		};

		return this.http.post(this._gS.service_url + 'timeline/list_hollidays', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	constructor(private http: HttpClient, public _gS: GlobalService) { }
}
